import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4f2ed7e"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f2ed7e')) {
      api.createRecord('f4f2ed7e', component.options)
    } else {
      api.reload('f4f2ed7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f4f2ed7e", function () {
      api.rerender('f4f2ed7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HelpText/index.vue"
export default component.exports